import { render, staticRenderFns } from "./orderdetail.vue?vue&type=template&id=0f1a7bb5&scoped=true&"
import script from "./orderdetail.vue?vue&type=script&lang=js&"
export * from "./orderdetail.vue?vue&type=script&lang=js&"
import style0 from "./orderdetail.vue?vue&type=style&index=0&id=0f1a7bb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1a7bb5",
  null
  
)

export default component.exports